import React from 'react'
import styled from '@emotion/styled'
import LoadingIcon from '../components/LoadingIcon'

const Container = styled.div`
  width: 100%;
  display: flex;
  margin: 40px 0;
  justify-content: space-around;
`

type Props = {
  children?: any
}

const LoadingContainer = ({ children }: Props) => (
  <Container>
    <LoadingIcon />
    {children}
  </Container>
)

export default LoadingContainer
